import React, { useContext, useState } from "react";
import { get, isEmpty } from "lodash";
import { LoaderWrapper, ManagePlanLayout } from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
} from "../../../utils";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import { listFunding } from "../../../services";
import PlanCashAccountDetails from "./PlanCashAccountDetails";
import ForfeitureAccount from "./ForfeitureAccount";
import ACHDebit from "./ACHDebit";

const ManageFundingsContainer = (props) => {
  const { flow, planId } = useRouterParams();
  const { history } = props;
  const [planCashToggle, setPlanCashToggle] = useState(false);
  const [forfeitureToggle, setForfeitureToggle] = useState(false);
  const [achToggle, setACHToggle] = useState(false);

  const { response, loading: isloading } = useRequest({
    method: listFunding,
    payload: parseInt(planId),
    defaultResponse: {},
  });

  const fundingData = get(response, "funding", {});

  useDeepEffect(() => {
    if (fundingData) {
      setACHToggle(fundingData?.achAccountEnabled);
      setPlanCashToggle(fundingData?.planCashAccountEnabled);
      setForfeitureToggle(fundingData?.forfeitureAccountEnabled);
    }
  }, [fundingData]);

  const goForward = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING_DETAIL,
        pathParam: [planId],
      })
    );
  };
  return (
    <LoaderWrapper isLoading={isloading}>
      <ManagePlanLayout pageFlow={flow}>
        <div className="d-flex w-100 align-items-center justify-content-between mb-4"></div>
        <div>
          <PlanCashAccountDetails
            planId={planId}
            fundingId={fundingData?.id}
            planCashToggle={planCashToggle}
            setPlanCashToggle={setPlanCashToggle}
            forfeitureToggle={forfeitureToggle}
            achToggle={achToggle}
          />
        </div>

        <br></br>
        <div>
          <ForfeitureAccount
            planId={planId}
            fundingId={fundingData?.id}
            forfeitureToggle={forfeitureToggle}
            setForfeitureToggle={setForfeitureToggle}
            achToggle={achToggle}
            planCashToggle={planCashToggle}
          />
        </div>

        <br></br>
        <div>
          <ACHDebit
            planId={planId}
            fundingId={fundingData?.id}
            sponsorAccounts={fundingData?.sponsorFundingAccounts}
            achToggle={achToggle}
            setACHToggle={setACHToggle}
            forfeitureToggle={forfeitureToggle}
            planCashToggle={planCashToggle}
          />
        </div>
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default ManageFundingsContainer;
